import type { AxiosInstance } from 'axios'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'searches'

// Admin-specific types
export interface FirmSummary {
  _id: string
  company: string
  code: string
  isDedicatedServer: boolean
}

export interface SearchLogMetadata {
  requestId: string
  authorId: string
  _firmId: string
  type: string
  provider: string
  model: string
  totalTokens: number
  userQuery: string
  aiResponse: string
  like?: boolean
  comment?: string
  foundInDocuments?: boolean
  author: {
    _id: string
    firstname: string
    lastname: string
    picture?: string
    _firmId: string
    firm: {
      company: string
    }
  }
}

export interface SearchLog {
  _id: string
  timestamp: string
  metadata: SearchLogMetadata
}

export interface AdminSearchHistoryResponse {
  searches: SearchLog[]
}

// List all firms for admin selection
const listFirms = (axios: any) => () => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/admin/firms`,
  })
}

// Get search history with optional firm filter
const getHistory = (axios: any) => (query: {
  firmId?: string
  page?: number
  limit?: number
  sort?: string
  order?: number
  startDate?: string | Date
  endDate?: string | Date
  authorIds?: string[]
}) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/admin/history`,
    query,
  })
}

export default (axios: AxiosInstance) => ({
  listFirms: listFirms(useAxios(axios)),
  getHistory: getHistory(useAxios(axios)),
})
